import { Component, OnInit } from '@angular/core';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { faFileSignature } from '@fortawesome/free-solid-svg-icons';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

import * as $ from 'jquery';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  faHome = faHome;
  faCalendarAlt = faCalendarAlt;
  faInfoCircle = faInfoCircle;
  faFileSignature = faFileSignature;
  faFileAlt = faFileAlt;
  faGlobe = faGlobe;
  faFileInvoiceDollar = faFileInvoiceDollar;
  faPhone = faPhone;
  linkMapaMunicipios;

  token: string;

  constructor(
    private route: ActivatedRoute
  ) { }

  ngOnInit() {

    this.token = sessionStorage.getItem("loginAuth");
    this.linkMapaMunicipios = environment.linkMapaMunicipios;

    $('.li-seta').click(function () {

      if ($('.li-seta').hasClass('ativo')) { //FECHA O SIDE
        $('.li-seta').removeClass('ativo');
        $('.content-inner').animate({ paddingLeft: '6.8rem' });
        $('.navbar-minimal.open').css('width', '80px');
        $('.fa-angle-double-left').addClass('fa-angle-double-right');
        $('.fa-angle-double-left').removeClass('fa-angle-double-left');
        $('li a span').addClass('desc');
        $('li a').removeClass('text-right');
        $('li a').addClass('text-center');
        $('li a span').css('margin', '-20px 0 0 35px');
        $('.nomeExpandir').html(' Expandir Menu ');
      } else { //ABRE O SIDE
        $('.li-seta').addClass('ativo');
        $('.content-inner').animate({ paddingLeft: '18rem' });
        $('.navbar-minimal.open').css('width', '260px');
        $('.fa-angle-double-right').addClass('fa-angle-double-left');
        $('.fa-angle-double-right').removeClass('fa-angle-double-right');
        $('li a span').removeClass('desc');
        $('li a').removeClass('text-center');
        $('li a').addClass('text-right');
        $('li a span').css('margin', '10px');
        $('li a i').css('width', '20px');
        $('.nomeExpandir').html(' Recolher Menu ');
      }
    });
  }

close(pop:any){
  pop.close()
}

linkBalcaoUnico(){
  window.location.href =  environment.linkBalcaoUnico + this.token;
}

public linkCPFBloqueado(event){
  window.location.href =  environment.linkCPFBloqueado + this.token;
}

}
